<template>
    <div class="row">
        <div class="col-md-5">
            <hr class="d-md-none mb-3">
            <form @submit.prevent="getResults()" class="form-inline">
                <label class="sr-only" for="search">Search</label>
                <input type="text" class="form-control searchbar-input mr-sm-2 w-60 w-mobile-100" :class="{'border border-danger' : error}" id="search" v-model="searchParams.patientText" :placeholder="`Search for a patient name, ${patientIdentifierLabel.toLowerCase()} or test no`">

                <button onclick="this.blur();" :disabled="loading" type="submit" class="btn btn-success btn-form sm-shadow btn-block-mobile mt-2 mt-sm-0" :class="{disabled : loading}">Search <span v-if="loading" class="btn-loading"></span></button>
            </form>

            <small v-if="error" class="d-block text-danger">
                Please enter a patient name, {{ patientIdentifierLabel }} or test no to search
            </small>

            <router-link :to="{name: 'AdvancedSearch'}" class="underlined font-weight-bold text-sm d-inline-block mt-1">Advanced search</router-link>

            <hr class="d-md-none mt-3 mb-0">
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'SearchbarComponent',

    data() {
        return {
            loading: false,
            query: null,
            error: false
        }
    },

    computed: {
        ...mapGetters({
            organisationId: 'UserStore/GetUserOrganisationId',
            facilityId: 'UserStore/GetUserFacilityId',
            patientText: 'SearchStore/GetPatientText',
            patientIdentifierLabel: 'OrganisationStore/GetPatientIdentifierLabel',
            searchParams: 'SearchStore/GetSearchParams'
        })
    },

    mounted() {
        if (this.$route.name !== 'SearchResults') {
            this.clearSearchStore()
        }
    },

    methods: {
        ...mapActions({
            setSearchbarDataInSearchStore: 'SearchStore/SetSearchbarData',
            setNotification: 'NotificationStore/SetNotification',
            clearSearchStore: 'SearchStore/ClearSearchStore'
        }),

        async getResults() {
            this.loading = true
            this.error = false

            if(!this.patientText) {
                this.loading = false
                this.error = true
            }

            if(!this.error) {
                
                let searchModel = {
                    organisationId: this.organisationId,
                    patientText: this.patientText,
                    pageSize: process.env.VUE_APP_PAGINATION_PAGE_SIZE,
                    offset: 0,
                    sortColumn: "TEST_NUMBER",
                    sortType: "DESCENDING"
                }

                try {
                    let response = await axios.post(`${process.env.VUE_APP_AXIOS_DIAGNOSTIC_BASE_URL}/api/v1/tests/search`, searchModel)
                
                    this.setSearchbarDataInSearchStore({
                        results: response.data, 
                        patientText: this.patientText
                    })

                    if(this.$route.name != 'SearchResults') this.$router.push({name: 'SearchResults'})
                }
                catch {
                    this.setNotification({
                        type: 'error',
                        title: 'Error',
                        message: 'An error occurred while fetching the results. Please try again'
                    })
                }
                finally {
                    this.loading = false
                }
            }
        }
    }
}
</script>